import {
	MAX_TRANSFER_OUT,
	MIN_TRANSFER_OUT,
} from "@/constants/common-constants";
import {
	currencyFormatter,
	isValidAmount,
	meetsMaximumTransfer,
} from "@/lib/utils";
import { z } from "zod";

const baseAmountSchema = z
	.string()
	.min(1, "Amount is required")
	.superRefine((val, ctx) => {
		if (!isValidAmount(val)) {
			ctx.addIssue({
				code: z.ZodIssueCode.custom,
				message: "Invalid amount",
			});
		}

		if (Number(val) < MIN_TRANSFER_OUT) {
			ctx.addIssue({
				code: z.ZodIssueCode.custom,
				message: `Minimum transaction amount is ${currencyFormatter.format(
					MIN_TRANSFER_OUT,
				)}`,
			});
		}

		if (!meetsMaximumTransfer(val, MAX_TRANSFER_OUT)) {
			ctx.addIssue({
				code: z.ZodIssueCode.custom,
				message: `Maximum transaction amount is ${currencyFormatter.format(
					MAX_TRANSFER_OUT,
				)}`,
			});
		}
	});

const paymentMethodSchema = z.enum(["instant", "standard"], {
	required_error: "Please select a payment method",
});

const termsAcceptedSchema = z.boolean().refine((val) => val === true, {
	message: "You must accept the terms and conditions",
});

export const baseWithdrawSchema = z.object({
	amount: baseAmountSchema,
	paymentMethod: paymentMethodSchema,
	termsAccepted: termsAcceptedSchema,
});

export type WithdrawFormData = z.infer<typeof baseWithdrawSchema>;

export const createWithdrawSchema = (maxAmount: number) => {
	return z.object({
		amount: baseAmountSchema.refine((val) => Number(val) <= maxAmount, {
			message: `Amount cannot exceed ${currencyFormatter.format(maxAmount)}`,
		}),
		paymentMethod: paymentMethodSchema,
		termsAccepted: termsAcceptedSchema,
	});
};
